import React, { FunctionComponent } from 'react';
import { MetaDataModel } from '../../../services/content/meta/models/MetaDataModel';
import styles from '../../../styles/Pagination.module.scss';
import { PaginationControl } from 'react-bootstrap-pagination-control';

export type Props = {
    onPageClick: (page: number) => void;
    meta: MetaDataModel | null;
    page: string;
};

export const Pagination: FunctionComponent<Props> = ({ meta, onPageClick, page }) => {
    if (meta && meta.pagination.totalPages > 1) {
        return (
            <div className={`${styles.container} react-boostrap-pagination-control`}>
                <PaginationControl
                    page={parseInt(page)}
                    between={2}
                    total={meta.pagination.total || 0}
                    limit={20}
                    last={true}
                    changePage={onPageClick}
                    ellipsis={0}
                />
            </div>
        );
    }

    return null;
};
